import { NavTabs } from '@space-core/components/navTabs'
import styled from 'styled-components'

export const CustomNavTab = styled(NavTabs)`
  .hot-nav__item--active {
    box-shadow: inset 0 calc(var(--spacer-1) / 2 * -1) 0 0 var(--blue) !important;
  }
`
CustomNavTab.displayName = 'CustomNavTab'

export const CustomNavTabItemLabel = styled.p<{ $isActive?: boolean }>`
  ${({ $isActive }) => `
    color: ${$isActive ? 'var(--blue)' : 'var(--gray-500)'};
  `}
`
CustomNavTabItemLabel.displayName = 'CustomNavTabItemLabel'

export const CustomButtonTab = styled.button`
  position: relative;

  &.isUnread {
    &::after {
      content: '';
      background-color: var(--red);
      height: 0.5rem;
      width: 0.5rem;
      position: absolute;
      top: 0;
      right: -0.5rem;
      border-radius: 50%;
    }
  }

  &:focus {
    outline: none;
  }
`
CustomButtonTab.displayName = 'CustomButtonTab'
